import { http } from '../../../../api/axios';
import { localContentPrefix } from '../../../../config';
import { ProductMetaData } from '../../../../../models/Product';
import { MarketplaceProductOut } from '../../../../store/apiLibx';

export type ExtendedMarketplaceProduct = MarketplaceProductOut & {
    loanFormat: string;
    id: string;
};

export interface AdditionalLibxProps {
    activeLibraries?: number;
    copyAmount?: number;
    alreadyInCollection?: boolean;
}

export const fetchLibxProduct = (id: string) => {
    return http
        .get<ProductMetaData & ExtendedMarketplaceProduct>(`${localContentPrefix}/v1/marketplace/products/:id`, {
            pathParams: { id }
        })
        .then(response => response.data);
};
